export const waitTime = 5 /* minutes */
